/*
 * Copyright (c) 2023. Haodong JU
 */

import { collection, doc, getDoc, query, setDoc } from 'firebase/firestore'
import { FireBaseStore } from '@/model/firebase/google-fire-base'
import { getCurrentStoreId } from '@/model/dataLayer/api/SaaS/user'
import dayjs from 'dayjs'
import { resultOfId } from '@/model/firebase/queryUtils'
import hillo from 'hillo'

const storeCost = 'storeCost'
const storeFixedCost = 'storeFixedCost'
const storePurchasingCost = 'storePurchasingCost'
const storeFixedDefaultList = 'storeFixedDefaultList'
const storePurchasingDefaultList = 'storePurchasingDefaultList'
const storeFixedExtraList = 'storeFixedExtraList'
const storePurchasingExtraList = 'storePurchasingExtraList'

export const todayYYYYMM = dayjs().format('YYYY-MM')

export async function addPurchasingCost (purchaseList, date) {
  const purchaseRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storePurchasingCost, date)
  await setDoc(purchaseRef, { purchaseList })
}

export async function getPurchasingCost (date) {
  const purchaseRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storePurchasingCost, date)
  return (await getDoc(purchaseRef)).data()?.purchaseList ?? []
}

export async function addFixedCost (fixedList, date) {
  const fixedRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storeFixedCost, date)
  await setDoc(fixedRef, { fixedList })
}

export async function getFixedCost (date) {
  const fixedRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storeFixedCost, date)
  return (await getDoc(fixedRef)).data()?.fixedList ?? []
}

export async function getReportDate () {
  const ref = query(collection(FireBaseStore, storeCost, await getCurrentStoreId(), storeFixedCost))
  return (await resultOfId(ref)).map(it => it.id)
}

export async function settingFixedExtraCost (list) {
  const defaultRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storeFixedExtraList, 'list')
  await setDoc(defaultRef, { list })
}

export async function getFixedExtraCostList () {
  const defaultRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storeFixedExtraList, 'list')
  return (await getDoc(defaultRef)).data()?.list ?? []
}

export async function settingPurchasingExtraCost (list) {
  const defaultRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storePurchasingExtraList, 'list')
  await setDoc(defaultRef, { list })
}

export async function getPurchasingExtraCostList () {
  const defaultRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storePurchasingExtraList, 'list')
  return (await getDoc(defaultRef)).data()?.list ?? []
}

export async function settingFixedDefaultCost (list) {
  const defaultRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storeFixedDefaultList, 'list')
  await setDoc(defaultRef, { list })
}

export async function getFixedDefaultCostList () {
  const defaultRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storeFixedDefaultList, 'list')

  return (await getDoc(defaultRef)).data()?.list ?? []
}

export async function settingPurchasingDefaultCost (list) {
  const defaultRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storePurchasingDefaultList, 'list')
  await setDoc(defaultRef, { list })
}

export async function getPurchasingDefaultCostList () {
  const defaultRef = doc(FireBaseStore, storeCost, await getCurrentStoreId(), storePurchasingDefaultList, 'list')
  return (await getDoc(defaultRef)).data()?.list ?? []
}

export const getFirstTimeZBon = async function () {
  const res = (await hillo.get('ZBon.php?op=searchZbonCombinedRecord', {
    fromDateTime: '2019-01-01 04:00:00',
    toDateTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
  })).content
  return dayjs(res?.slice(-1)[0]?.toTimestamp ?? '').format('YYYY-MM-DD')
}
